import { memo } from 'react'
import { Dialog, SxProps } from '@mui/material'
import { Box, Spinner } from '@/components'
import { BookSeatsBlackLogo } from '@/assets'
import { fullscreenLoaderStyles as styles } from './FullscreenLoader.style'
import { FullscreenLoaderProps } from './FullscreenLoader.types'

function FullscreenLoader({
  open,
  dialogProps = {},
  containerProps = {},
  logoProps = {},
  spinnerProps = {},
}: FullscreenLoaderProps) {
  const { sx: dialogSx, ...otherDialogProps } = dialogProps
  const { sx: containerSx, ...otherContainerProps } = containerProps
  const { sx: logoSx, ...otherLogoProps } = logoProps

  return (
    <Dialog open={open} fullScreen sx={[styles.dialog, dialogSx] as SxProps} {...otherDialogProps}>
      <Box sx={[styles.container, containerSx] as SxProps} {...otherContainerProps}>
        <Box
          component={BookSeatsBlackLogo}
          sx={[styles.logo, logoSx] as SxProps}
          {...otherLogoProps}
        />
        <Spinner size={30} {...spinnerProps} />
      </Box>
    </Dialog>
  )
}
export default memo(FullscreenLoader)
